// ✅ Function to block Shopify's AJAX tracking on the search field
function disableShopifyAjaxOnSearch() {
    document.querySelectorAll(".filter-search").forEach(function (searchInput) {
        searchInput.setAttribute("autocomplete", "off");
        searchInput.setAttribute("data-no-ajax", "true"); // Prevents Shopify from tracking it
        searchInput.setAttribute("form", "none"); // Stops Shopify from auto-submitting

        // Make sure Shopify doesn't override our event listeners
        searchInput.removeEventListener("input", handleFilterSearch);
        searchInput.removeEventListener("keydown", stopPropagation);

        // Reattach event listeners
        searchInput.addEventListener("keydown", stopPropagation);
        searchInput.addEventListener("input", handleFilterSearch);
    });
}

// ✅ Prevents event bubbling (fixes conflicts)
function stopPropagation(event) {
    event.stopPropagation();
}

// ✅ Handles the search filter logic
function handleFilterSearch(event) {
    event.preventDefault();
    event.stopPropagation();

    let searchValue = normalizeText(this.value.toLowerCase());
    let filterGroup = this.closest(".filter-group");
    let filterOptions = filterGroup.querySelectorAll(".sidebar__item");

    let showMoreButton = filterGroup.querySelector("[data-show-more]");

    if (showMoreButton) {
        showMoreButton.click();
    }

    filterOptions.forEach(function (option) {
        let label = option.querySelector("label").innerText;
        let normalizedLabel = normalizeText(label.toLowerCase());

        option.style.display = normalizedLabel.includes(searchValue) ? "block" : "none";
    });
}

// ✅ Normalize text (removes accents)
function normalizeText(text) {
    return text.normalize("NFD").replace(/[̀-ͯ]/g, "");
}

// ✅ Detect when Shopify reloads products via AJAX and reinitialize search
function observeFilterUpdates() {
    const filterContainer = document.querySelector(".collection__filters");

    if (!filterContainer) return;

    const observer = new MutationObserver(() => {
        setTimeout(disableShopifyAjaxOnSearch, 200); // Ensure Shopify tracking is removed
    });

    observer.observe(filterContainer, { childList: true, subtree: true });
}

// ✅ Force Shopify to reapply fix after every AJAX update
function forceFixAfterAjax() {
    disableShopifyAjaxOnSearch();
    observeFilterUpdates();

    // Listen for Shopify section updates
    document.addEventListener("shopify:section:load", function () {
        setTimeout(disableShopifyAjaxOnSearch, 200);
    });

    // Listen for URL changes (Shopify AJAX navigation)
    let lastUrl = location.href;
    new MutationObserver(() => {
        if (location.href !== lastUrl) {
            lastUrl = location.href;
            setTimeout(disableShopifyAjaxOnSearch, 200);
        }
    }).observe(document.body, { childList: true, subtree: true });
}

// ✅ Run the fix when the page loads
document.addEventListener("DOMContentLoaded", forceFixAfterAjax);

// Zoom mobile/PC
document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth <= 768) {
        document.querySelectorAll(".pswp__button--arrow--left, .pswp__button--arrow--right").forEach(el => el.remove());
    }
});

// Sélecteur du nombre de colonnes sur la page Collection (3 / 4 / 5)
(function () {
    var STORAGE_KEY = "norev_collection_columns";
    var ALLOWED = ["3", "4", "5"];

    function applyColumns(section, cols) {
        if (!section || ALLOWED.indexOf(String(cols)) === -1) return;
        section.style.setProperty("--COLUMNS", cols);
        section.style.setProperty("--COLUMNS-WIDESCREEN", cols);
        var btns = section.querySelectorAll(".collection-columns__btn");
        btns.forEach(function (b) {
            var isActive = b.getAttribute("data-columns") === String(cols);
            b.classList.toggle("is-active", isActive);
            b.setAttribute("aria-pressed", isActive ? "true" : "false");
        });
    }

    function readStored() {
        try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
    }

    function writeStored(cols) {
        try { localStorage.setItem(STORAGE_KEY, cols); } catch (e) {}
    }

    function initCollectionColumns(root) {
        var sections = (root || document).querySelectorAll(".collection-products");
        var stored = readStored();
        sections.forEach(function (section) {
            if (!section.querySelector(".collection-columns")) return;
            if (stored && ALLOWED.indexOf(stored) !== -1) {
                applyColumns(section, stored);
            }
        });
    }

    document.addEventListener("click", function (e) {
        var btn = e.target.closest(".collection-columns__btn");
        if (!btn) return;
        e.preventDefault();
        var cols = btn.getAttribute("data-columns");
        var section = btn.closest(".collection-products");
        applyColumns(section, cols);
        writeStored(cols);
    });

    document.addEventListener("DOMContentLoaded", function () {
        initCollectionColumns();

        // Re-applique le choix de l'utilisateur après les recharges de section
        // déclenchées par les filtres / tri de Shopify (Section Rendering API).
        var lastUrl = location.href;
        new MutationObserver(function () {
            if (location.href !== lastUrl) {
                lastUrl = location.href;
                setTimeout(initCollectionColumns, 200);
            }
        }).observe(document.body, { childList: true, subtree: true });
    });
    document.addEventListener("shopify:section:load", function (event) { initCollectionColumns(event.target); });
})();


// Complète la dernière ligne de la grille collection.
//
// La pagination est fixée à 100 produits, ce qui tombe juste pour les vues
// 2, 4 et 5 colonnes mais laisse 1 produit orphelin en vue 3 (33 lignes + 1).
// On récupère alors les premiers produits de la page suivante pour finir la
// ligne. Ces produits réapparaissent en tête de la page suivante, c'est voulu.
//
// Le nombre de colonnes est lu sur la grille elle-même plutôt que sur le
// réglage : il change aussi aux breakpoints (3 en 750-989px, 2 en dessous),
// et le compte réel de vignettes peut être inférieur à 100, les produits
// tagués `archive` étant sautés au rendu.
(function () {
    var FILLER = "data-row-filler";
    var cache = {};

    function gridOf(section) {
        return section.querySelector("#CollectionLoop");
    }

    function childItems(grid, includeFillers) {
        var out = [];
        for (var i = 0; i < grid.children.length; i++) {
            var el = grid.children[i];
            if (!el.hasAttribute("data-grid-item")) continue;
            if (!includeFillers && el.hasAttribute(FILLER)) continue;
            out.push(el);
        }
        return out;
    }

    // Nombre de colonnes réellement rendues, via les pistes calculées du grid.
    function columnCount(grid) {
        var tpl = window.getComputedStyle(grid).gridTemplateColumns || "";
        var tracks = tpl.split(/\s+/).filter(function (t) {
            return /^[\d.]+px$/.test(t);
        });
        if (tracks.length) return tracks.length;

        // Repli : compte les vignettes alignées sur la première ligne.
        var items = childItems(grid, true);
        if (!items.length) return 0;
        var top = items[0].offsetTop;
        var n = 0;
        while (n < items.length && items[n].offsetTop === top) n++;
        return n;
    }

    function clearFillers(grid) {
        var fillers = grid.querySelectorAll("[" + FILLER + "]");
        for (var i = 0; i < fillers.length; i++) fillers[i].remove();
    }

    function missingCount(grid) {
        var cols = columnCount(grid);
        if (cols < 2) return 0;
        var count = childItems(grid, false).length;
        if (!count) return 0;
        var remainder = count % cols;
        return remainder === 0 ? 0 : cols - remainder;
    }

    function fetchItems(url) {
        return fetch(url, { credentials: "same-origin" })
            .then(function (r) {
                if (!r.ok) throw new Error(r.status);
                return r.text();
            })
            .then(function (html) {
                var doc = new DOMParser().parseFromString(html, "text/html");
                var loop = doc.querySelector("#CollectionLoop");
                return loop ? childItems(loop, true) : [];
            });
    }

    function nextPageItems(section) {
        var link = section.querySelector(".pagination-custom__next");
        if (!link || !link.href) return null;
        var url = link.href;

        if (!cache[url]) {
            // Section Rendering API d'abord : évite de rapatrier l'en-tête,
            // le pied de page et les autres sections du document.
            var id = section.getAttribute("data-section-id");
            var sectionUrl = id
                ? url + (url.indexOf("?") === -1 ? "?" : "&") + "section_id=" + encodeURIComponent(id)
                : null;

            cache[url] = (sectionUrl ? fetchItems(sectionUrl) : Promise.resolve([]))
                .catch(function () { return []; })
                .then(function (items) {
                    return items.length ? items : fetchItems(url);
                })
                .catch(function () { return []; });
        }
        return cache[url];
    }

    function completeRows(section) {
        var grid = gridOf(section);
        if (!grid) return;

        clearFillers(grid);
        if (!missingCount(grid)) return;

        var request = nextPageItems(section);
        if (!request) return; // dernière page : rien à compléter

        request.then(function (items) {
            // La grille a pu être remplacée ou la vue changée entre-temps.
            if (!items.length || !document.contains(grid)) return;
            clearFillers(grid);
            var needed = missingCount(grid);
            if (!needed) return;

            items.slice(0, needed).forEach(function (item) {
                var clone = item.cloneNode(true);
                clone.setAttribute(FILLER, "");
                clone.removeAttribute("id");
                // Sans ça les vignettes restent masquées : AOS ne rescanne pas.
                var animated = clone.querySelectorAll("[data-aos]");
                for (var i = 0; i < animated.length; i++) {
                    animated[i].removeAttribute("data-aos");
                }
                if (clone.hasAttribute("data-aos")) clone.removeAttribute("data-aos");
                grid.appendChild(clone);
            });
        });
    }

    function run(root) {
        var sections = (root || document).querySelectorAll(".collection-products");
        for (var i = 0; i < sections.length; i++) completeRows(sections[i]);
    }

    // Après le handler du sélecteur de colonnes, qui vient plus haut.
    document.addEventListener("click", function (e) {
        if (e.target.closest(".collection-columns__btn")) run();
    });

    var resizeTimer;
    window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(run, 200);
    });

    document.addEventListener("DOMContentLoaded", function () {
        run();

        // Filtres et tri rechargent la grille via la Section Rendering API.
        var lastUrl = location.href;
        new MutationObserver(function () {
            if (location.href !== lastUrl) {
                lastUrl = location.href;
                setTimeout(run, 300);
            }
        }).observe(document.body, { childList: true, subtree: true });
    });

    document.addEventListener("shopify:section:load", function (e) { run(e.target); });
})();

